module.exports = __webpack_public_path__ + "static/media/payment-success.293675ba.png";